// React
import React, { useState } from 'react';

// Components
import { useDispatch } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { ADGMImage } from 'aurora-components';
import { previewDocuments } from 'aurora-composition/modules/common/actions';
import Modal from '@material-ui/core/Modal';

// Utils
import { keyEmptyCheck, getFileIconName } from 'aurora-utils/utils';
import PropTypes from 'prop-types';

// styles
import classNames from 'classnames';
import { Divider } from '@material-ui/core';

const DocumentsView = ({
  classes,
  attributes,
  documents,
  handleViewFile,
  applicationId,
  applicationType,
  isPanel,
  // handleDownloadAllDocs,
  // hideDownloadAllBtn,
  viewDocumentButtonText,
  isHandlePreview,
}) => {
  let shouldShowDownloadAllButton = false;
  const dispatch = useDispatch();
  const [pdfBlob, setPdfBlob] = useState(null);
  const [previewstate, setPreviewstate] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };
  const savePDF = () => {
    const { attr, file } = previewstate;
    handleViewFile(attr.name, file.subType, file?.fileName, file);
    toggleModal();
  };
  const PdfPreview = (attr, file) => {
    const payload = {
      applicationId: applicationId || file?.applicationId,
      applicationType,
      documentType: attr.name,
      subType: file.subType,
      fileName: file?.fileName,
    };
    setPreviewstate({ attr, file });

    dispatch(previewDocuments(payload))
      .then(response => response.arrayBuffer())
      .then(data => {
        // Create a blob from the array buffer
        const blob = new Blob([data], { type: 'application/pdf' });
        setPdfBlob(blob);
        toggleModal();
      })
      .catch(error => console.error('Error fetching PDF:', error));
  };

  return (
    <>
      <Box className={classNames(isPanel && classes.panelBody, classes.container)}>
        {(attributes || [])?.map((attr, index) => {
          if (attr?.active && attr.attributeType.toLowerCase() === 'file') {
            // Documents as per section/field uploaded
            const currentSectionDocs = documents?.filter(
              doc =>
                doc.type === attr.name &&
                (attr?.subType ? doc.subType === attr.subType : true) &&
                (doc.userId
                  ? +doc.userId === +attr.userId
                  : doc.userId === null || typeof doc.userId === 'undefined') &&
                (doc.customerId
                  ? +doc.customerId === +attr.customerId
                  : doc.customerId === null || typeof doc.customerId === 'undefined') &&
                (doc.companyId
                  ? +doc.companyId === +attr.companyId
                  : doc.companyId === null || typeof doc.companyId === 'undefined'),
            );

            const isDocsExists = currentSectionDocs?.length > 0;

            // if shouldShowDownloadAllButton is not true
            if (!shouldShowDownloadAllButton) {
              shouldShowDownloadAllButton = isDocsExists;
            }

            return (
              isDocsExists && (
                <Box
                  className={classes.docViewBox}
                  pb={{ xs: '1em', lg: '1em' }}
                  pt='1em'
                  borderBottom={{
                    xs: '0',
                    lg: '1px solid #EBEEF3',
                  }}
                  key={`${attr.name}-view-${index + 1}`}
                >
                  <Box
                    display='flex'
                    alignItems='center'
                    mb='12px'
                    // mb={{ xs: '1em', lg: '0' }}
                  >
                    <Typography component='p' className={classes.docViewTitle}>
                      <span>{keyEmptyCheck(attr.title)}</span>
                      {attr?.customBadge && attr?.customBadge(currentSectionDocs)}
                    </Typography>
                  </Box>
                  <Divider />
                  <Box display='flex' flexDirection='column' gridGap='12px'>
                    <Box className={classes.docViewContent}>
                      {currentSectionDocs?.map((file, idx) => (
                        <Box
                          display='flex'
                          justifyContent='space-between'
                          alignItems='center'
                          pt='12px'
                          key={file.id}
                          marginBottom={{
                            xs: idx === currentSectionDocs.length - 1 ? 0 : '12px',
                            md: 0,
                          }}
                        >
                          <Box display='flex' alignItems='center' width={{ xs: 'auto', md: '70%', lg: 'auto' }}>
                            <Box
                              display='flex'
                              justifyContent='center'
                              alignItems='center'
                              className={classNames(classes.docIcon, classes.docViewIcon)}
                            >
                              <ADGMImage
                                name={getFileIconName(file.fileName)}
                                width='16.67px'
                                minWidth='16.67px'
                                alt='document'
                              />
                            </Box>
                            <Typography component='p' className={classNames(classes.fileName, classes.actionBtn)}>
                              {file.fileName}
                            </Typography>
                          </Box>
                          <Box className={classes.fileActionsContainer}>
                            <Button
                              variant='outlined'
                              component='span'
                              id={attr.id}
                              name={attr.name}
                              className={classes.viewBtn}
                              onClick={() =>
                                isHandlePreview && file?.fileExtension === 'application/pdf'
                                  ? PdfPreview(attr, file)
                                  : handleViewFile(attr.name, file.subType, file?.fileName, file)
                              }
                            >
                              <ADGMImage
                                name='view-small-black.svg'
                                className={classes.uploadIcon}
                                width='14px'
                                alt='View Icon'
                              />

                              <Typography component='p'>{keyEmptyCheck(viewDocumentButtonText)}</Typography>
                            </Button>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                    {attr.extraChild && <>{attr.extraChild(currentSectionDocs)}</>}
                  </Box>
                </Box>
              )
            );
          }
          return null;
        })}
        {/* {shouldShowDownloadAllButton && !hideDownloadAllBtn && (
          <Box textAlign='center' pt='1em' pb='1.5em' borderTop={{ xs: '1px solid #EBEEF3', md: 0 }}>
            <Button variant='text' className={classes.downloadAllbtn} onClick={handleDownloadAllDocs}>
              <ADGMImage name='download.png' width='12px' alt='Download Icon' /> {keyEmptyCheck('download_all')}
            </Button>
          </Box>
        )} */}
      </Box>
      <Modal
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        open={isModalOpen}
        toggleModal={toggleModal}
        onClose={toggleModal}
        className={classNames(classes.modalMain)}
      >
        <div className={classNames(classes.modal, classes.modalpaper)}>
          <ADGMImage
            name='close.svg'
            alt='crossicon'
            className={classes.crossIconimg}
            onClick={toggleModal}
            aria-hidden='true'
          />
          <div className={classes.modaltitlehead}>
            <Typography component='h2' className={classes.docViewTitle}>
              <span>{previewstate && previewstate?.file?.fileName}</span>
            </Typography>
          </div>
          {pdfBlob && (
            <embed
              title='PDF Viewer'
              width='100%'
              height='500px'
              src={URL.createObjectURL(pdfBlob)}
              type='application/pdf'
              className={classes.pdfArea}
            />
          )}
          <div className={classNames(classes.modalBtnholder, classes.feedbackmodalBtnholder)}>
            <Button
              variant='contained'
              className={classNames(classes.btns, classes.TerminateBtn)}
              size='large'
              onClick={savePDF}
            >
              <ADGMImage name='Download-Icon.svg' alt='BackClose' className={classes.mobilebackarrow} />
              {keyEmptyCheck('save_as_pdf')}
            </Button>
            <Button
              variant='contained'
              className={classNames(classes.btns, classes.accptBtn)}
              size='large'
              onClick={toggleModal}
            >
              {keyEmptyCheck('done')}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

DocumentsView.propTypes = {
  classes: PropTypes.object.isRequired,
  documents: PropTypes.array.isRequired,
  attributes: PropTypes.array.isRequired,
  handleViewFile: PropTypes.func.isRequired,
  // handleDownloadAllDocs: PropTypes.func.isRequired,
  isPanel: PropTypes.bool.isRequired,
  isHandlePreview: PropTypes.bool.isRequired,
  // hideDownloadAllBtn: PropTypes.bool.isRequired,
  viewDocumentButtonText: PropTypes.string.isRequired,
  applicationId: PropTypes.string.isRequired,
  applicationType: PropTypes.string.isRequired,
};

export default DocumentsView;
